module.exports = __webpack_public_path__ + "img/18-2.adf79173.png";